import React, { useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import { handbag, shirt, shp } from "../../constant";
import "../../assets/css/AllPlants.css";
import ProductCard from "../../Components/Cards/ProductCard";
import ReactPaginate from "react-paginate";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import AllPlantsCard from "./AllPlantsCard";
import { useEffect } from "react";
import { GetAllFilterApi, GetPlantsApi } from "../../network/Network";
import Skeleton from "react-loading-skeleton";
import NoRecord from "../../Components/NoRecord/NoRecord";
import { useSelector } from "react-redux";

function Products() {
  const CategoriesReduxData = useSelector(
    (state) => state.AuthReducer.categories
  );
  const [productsData, setProductsData] = useState([]);
  const [spinLoad, setSpinLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState();

  const [startPrice, setStartPrice] = useState("");
  const [endPrice, setEndPrice] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filtersData, setFiltersData] = useState([]);
  const [search, setSearch] = useState("");

  const handlePageClick = async (data) => {
    setCurrentPage(data?.selected + 1);
  };

  const ApplyFilters = (e = null, type) => {
    if (e) {
      e.preventDefault();
    }
    setSpinLoad(true);
    let data;
    if (type == "reset") {
      data = {
        name: "/other-products",
        start_price: " ",
        end_price: " ",
        category: " ",
        search: " ",
      };
      window.location.reload(false);
      setStartPrice("");
      setEndPrice("");
      setSelectedCategory("");
      setSearch("");
    } else {
      data = {
        name: "/other-products",
        start_price: type == "search" ? " " : startPrice,
        end_price: type == "search" ? " " : endPrice,
        category: type == "search" ? " " : selectedCategory,
        search: type == "filter" ? " " : search,
      };
    }
    GetPlantsApi(currentPage,data)
      .then((res) => {
        setProductsData(res?.data?.data);
        const total = res?.data?.total;
        const limit = res?.data?.per_page;
        setPageCount(Math.ceil(total / limit));
        setSpinLoad(false);
      })
      .catch((err) => {
        setSpinLoad(false);
      });
  };

  // Get ALL Products
  useEffect(() => {
    ApplyFilters(null);
  }, [currentPage]);

  // Get FILTERS Data
  useEffect(() => {
    GetAllFilterApi()
      .then((res) => {
        setFiltersData(res?.data);
      })
      .catch((err) => {
        // console.log(err);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cateData = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
    },
    {
      id: 4,
    },
  ];
  return (
    <div className="Product_Main">
      <Header />
      <MainBanner name={"Products"} />
      <section className="allPlants-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="filter-side">
                <div className="title-cont">
                  <h2 className="filter-title">Apply Filters</h2>
                </div>
                {/* maaz */}
                <div className="filter">
                  <div className="box">
                    <div className="title">
                      <h4>Category</h4>
                    </div>
                    <div>
                      <select
                        className="form-control my-select-drop-icon"
                        id="state"
                        name="state"
                        onChange={(e) => {
                          setSelectedCategory(e.target.value);
                        }}
                      >
                        <option selected="">Select Category</option>
                        {filtersData?.sub_category?.map((item, index) => {
                          return (
                            <option value={item?.id} key={index}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="price-range">
                    <div className="title">
                      <h4 className="text-white mt-4">Price</h4>
                    </div>
                    <div className="input-group">
                      <div className="form-group pr-2">
                        {/* <label for="From" className="text-white">From</label> */}
                        <input
                          type="text"
                          id="From"
                          className="form-control bg_white_products_clr"
                          placeholder="From"
                          value={startPrice}
                          onChange={(e) => setStartPrice(e.target.value)}
                        />
                      </div>
                      <div className="seprator"></div>
                      <div className="form-group pr-2">
                        {/* <label className="text-white" for="To">To</label> */}
                        <input
                          type="text"
                          id="To"
                          className="form-control bg_white_products_clr"
                          placeholder="To"
                          value={endPrice}
                          onChange={(e) => setEndPrice(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 mb-3">
                    <button
                      className="apply-filter-btn"
                      onClick={(e) => ApplyFilters(e, "filter")}
                    >
                      Apply Filters
                    </button>
                  </div>

                  <div className="mt-3 mb-3">
                    <button
                      className="apply-filter-btn"
                      onClick={() => {window.location.reload()}}
                      // onClick={(e) => ApplyFilters(e, "reset")}
                    >
                      Reset Filters
                    </button>
                  </div>
                </div>
                {/* maaz */}
                {/* <div className="search-bar-cont">
                  <input type="text" placeholder="Serach" className="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  /> */}
                  {/* onClick={(e) => ApplyFilters(e, "search")} */}
                {/* </div> */}
                {/* maaz */}
                {/* <p className="maincate-head">Category</p>
                {cateData?.map((item, index) => {
                  return (
                    <div className="cate-box" key={index}>
                      <p className="title">Lorem</p>
                      <input type="checkbox" value="Bike"></input>
                    </div>
                  );
                })} */}

                {/* <ActionButton />
                <p className="load-more">LOAD MORE</p> */}

                {/* <p className="maincate-head">Price</p> */}
                {/* <div className="row">
                  <div className="col-lg-6">
                    <label className="price-text">From</label>
                    <input
                      type="number"
                      className="price-filter"
                      placeholder="From"
                      value={startPrice}
                      onChange={(e) => setStartPrice(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="price-text">To</label>
                    <input
                      type="number"
                      className="price-filter"
                      placeholder="To"
                      value={endPrice}
                      onChange={(e) => setEndPrice(e.target.value)}
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <div className="col-lg-9">
              <div className="row">
                {spinLoad ? (
                  <>
                    {[0, 1, 2, 3, 4, 5]?.map((item, index) => {
                      return (
                        <div className="col-md-4 mt-3" key={index}>
                          <Skeleton count={5} />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {productsData?.length > 0 ? (
                      <>
                        {productsData?.map((item, index) => {
                          return (
                            <ProductCard
                            item={item} index={index}
                            colValue={"4"}
                            pageLink={"/premium-product"}
                          />
                            // <AllPlantsCard
                            //   item={item}
                            //   index={index}
                            //   colValue={"4"}
                            //   links="/"
                            // />
                          );
                        })}
                      </>
                    ) : (
                      <NoRecord />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="pagination-container mt-5">
            <ReactPaginate
              previousLabel="<"
              nextLabel=">"
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
            {productsData?.length > 0 ? (
              <p className="Total-Product">{productsData?.length} PRODUCTS 1 - {productsData?.length}</p>

            ) : null}

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Products;
